import React from 'react'
import Icon from 'shared/components/icon'
import { ListingColumns } from 'shared/components/listing/Listing'
import { Link } from 'react-router-dom'
import { Popconfirm } from 'antd'
import { ReadRegistrationDto } from '../../../api-client'
import { getFormattedDateTime } from '../../../shared/dates/formatters'

export const columns = (deleteItem: any): ListingColumns<ReadRegistrationDto> => [
  {
    title: 'First Name',
    dataIndex: 'firstName',
  },
  {
    title: 'Last Name',
    dataIndex: 'lastName',
  },
  {
    title: 'Created',
    dataIndex: 'dateCreated',
    render: (item) => <div>{getFormattedDateTime(item)}</div>,
  },
  {
    title: 'Appointment Time',
    dataIndex: 'appointmentTime',
    render: (item) => <div>{getFormattedDateTime(item)}</div>,
  },
  {
    title: 'Actions',
    render: (item) => (
      <div>
        <div>
          <Link to={`/app/manager/registrations/edit/${item.id}`}>Process</Link>
        </div>
        <div>
          <Popconfirm
            title="Delete this category?"
            onConfirm={() => deleteItem(item.id)}
            okText="Yes"
            cancelText="No"
          >
            <a href="#/">Delete</a>
          </Popconfirm>
        </div>
      </div>
    ),
  },
]
